module.exports = __webpack_public_path__ + "img/f47.e0f6fb43.png";